import React from 'react';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import {
    SprayEquipmentSetId,
    SprayApplicationRate,
    SprayProduct
} from 'services/sprayEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectRatePerTank } from './selectors';

interface ConnectedProps {
    ratePerTank: string;
}

export interface OwnProps {
    productId: ProductId;
    equipmentSetId: SprayEquipmentSetId;
    applicationRate: SprayApplicationRate;
    product: SprayProduct;
    unitTypeId: UnitTypeId;
}

export type Props = ConnectedProps & OwnProps;

export class RatePerTankListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { ratePerTank } = this.props;

        return <ListItem value={ratePerTank} description="Rate per tank" />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    ratePerTank: makeSelectRatePerTank()
});

export default connect(mapStateToProps)(RatePerTankListItemComponent);
